import Constants from '../../common/constants';

const imageFolder = `${Constants.IMAGE_FOLDER}destandvastige/`;

const title = "Holy Road - The Perseverer";
const description = "The Palestinian Sub Laban family lives in the Muslim quarter of the Old City of Jerusalem. In the old days, Jews used to live here. For that reason their house is now being expropriated.";
const featuredImage = `${imageFolder}destandvastige/omslag.jpg`;

export default [
    {
        type: "Meta",
        title: title,
        meta: [
            {"property": "og:title", "content": title},
            {"property": "og:url", "content": `${Constants.DOMAIN}${Constants.STORY_URL}destandvastige`},
            {"property": "description", "content": ""},
            {"property": "og:description", "content": description},
            {"property": "og:image", "content": featuredImage},
            {"property": "twitter:card", "content": `summary_large_image`},
            {"property": "twitter:title", "content": title},
            {"property": "twitter:description", "content": description},
            {"property": "twitter:image", "content": featuredImage},
        ]
    },
    {
        type: "Quote",
        quote: description,
    },
    {
        type: "Iframe",
        hideSpacer: true,
        url: "https://player.vimeo.com/video/248454229"
    },
    {
        type: "Paragraph",
        text: "The putty in the bedroom wall is still visible. Palestinian Nora Sub Laban points at seven spots on the wall: places where her neighbors drilled holes. “To check what was behind the wall, they said. But why would they drill seven times?” Nora Sub Laban’s neighbors in the Muslim Quarter of the Old City of Jerusalem, are Jewish settlers. The room next to the bedroom used to be part of the Sub Laban family’s house, but step by step the house is taken over by the neighbors."
    },
    {
        type: "Paragraph",
        text: "Absurd? Not in Jerusalem. Nora Sub Laban could go to the police, but they will not do anything for her. Even the Israeli judge approves of the Jewish neighbors, and the soldiers will only stand back and watch when yet another space is taken over. The legal battle of the family has gone on for decades but leads nowhere. This is the result of an Israeli law, which states that Jews can legitimately claim any Palestinian house where a Jew has ever lived. In the case of the Sub Laban family, it refers to a Jewish tenant in the 1930s."
    },
    {
        type: "Paragraph",
        text: "During the Arab-Israeli war of 1948 the Old City of Jerusalem was conquered by Jordan and since then the house is the property of the Sub Laban family. The judge has ruled that Nora and her husband are allowed to stay there – but they are the last generation. After them, the house will be released to settlers. During that same war, hundreds of Palestinian houses in what is now West Jerusalem were taken over by Jewish people. A few hundred meters from Nora Sub Laban’s house, just outside the Old City in the Musrara area, Arab mansions are now inhabited by Jews. The law is a one-way street and does not apply to these cases. No Palestinian could claim a house that was ever inhabited by his or her family. The Israeli law explicitly aims at enhancing Jewish presence in both Israel and the territories under its control, such as occupied East Jerusalem."
    }
]


// WEBPACK FOOTER //
// ./src/data/stories/story4.js